export default {
  placeholder: 'Search Mass.gov',
  buttonSearch: {}
};
